import React, { useState } from 'react';
import { Routes, Route, useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute'; // Import ProtectedRoute
import ProjectList from "./components/Professional/ProjectList";
import Footer from "./components/Footer";
import NotificationPopup from "./components/NotificationPopup";
import FiltersModal from './components/Professional/FiltersModal';
import SideBar from './components/SideBar';
import ProjectForm from './components/Professional/ProjectForm';
import AddSkillsForm from './components/Professional/AddSkillsForm';
import ProjectDetails from './components/Professional/ProjectDetails';
import AddWorkExperienceForm from './components/Professional/AddWorkExperienceForm';
import AddEducationForm from './components/Professional/AddEducationForm';
import Header from './components/Header';
import ProfessionalSignup from './components/Professional/ProfessionalSignup';
import Page from './components/profile1/page';
import Page2 from './components/profile2/page2';
import { useAuth } from './AuthContext'; // Import useAuth
import { encryptId, decryptId } from './utils/crypto'; // Import encryption utilities
import brandLogo from './assets/devgenius-logo.svg';

const ProfessionalRoutes = () => {
    const { user } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const { userId } = useParams();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const toggleNotification = () => setIsNotificationOpen(!isNotificationOpen);
    const toggleFiltersModal = () => setIsFiltersModalOpen(!isFiltersModalOpen);

    // Move params extraction here
    const simpleParams = new URLSearchParams(location.search);
    // Decrypt the option if present
    let simpleOption = simpleParams.get("option");
    if (simpleOption) {
        try {
            simpleOption = decryptId(simpleOption);
        } catch {
            simpleOption = null;
        }
    }

    return (
        <Routes>
            <Route path="/simple/:userId" element={
                <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                    <div style={{ padding: '16px 24px' }}>
                        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
                            <img src={brandLogo} alt="DevGenius logo" style={{ width: '32px', height: '32px', borderRadius: '8px' }} />
                            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'var(--text-primary)' }}>DevGenius</span>
                        </Link>
                    </div>
                    <div style={{ flex: 1 }}>
                        <div >
                            {simpleOption === "1" ? <Page /> : simpleOption === "2" ? <Page2 /> : null}
                        </div>
                    </div>
                </div>
            } />
            <Route path="/Page/:userId" element={
                <ProtectedRoute allowedRoles={['professional','client','admin']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        {(() => {
                            let profile = user?.profile;
                            if (!profile && location.state?.profile) {
                                profile = location.state.profile;
                            }
                            return profile === 1 ? (
                                <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                            ) : null;
                        })()}
                    <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <div style={{ flex: 1, marginLeft: isSidebarOpen ? 350 : 0, transition: 'margin-left 0.3s ease' }}>
                                {(() => {
                                    let profile = user?.profile;
                                    if (!profile && location.state?.profile) {
                                        profile = location.state.profile;
                                    }
                                    return profile === 1 ? (
                                        <Page toggleSidebar={toggleSidebar} />
                                    ) : profile === 2 ? (
                                        <Page2 toggleSidebar={toggleSidebar} />
                                    ) : null;
                                })()}
                            </div>
                        </div>
                    </div>
                </ProtectedRoute>
            } />

            <Route path="/ProSign-up" element={
                <div style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', background: 'var(--bg-base)', minHeight: '100vh' }}>
                    <Header type="proSignUp" />
                    <ProfessionalSignup />
                </div>
            } />
            <Route path="/ProProject" element={
                <ProtectedRoute allowedRoles={['professional']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                        <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <ProjectList
                                toggleSidebar={toggleSidebar}
                                isSidebarOpen={isSidebarOpen}
                                toggleFiltersModal={toggleFiltersModal}
                                userId={user?.id || 0}
                            />
                        </div>
                        <Footer />
                        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
                        {isFiltersModalOpen && <FiltersModal close={() => setIsFiltersModalOpen(false)} />}
                    </div>
                </ProtectedRoute>
            } />
            <Route path="/ProjectDetails/:id" element={
                <ProtectedRoute allowedRoles={['professional']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                        <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <ProjectDetails userId={user?.id || 0} />
                        </div>
                        <Footer />
                        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
                    </div>
                </ProtectedRoute>
            } /> 
            <Route path="/AddProject" element={
                <ProtectedRoute allowedRoles={['professional']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                        <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <ProjectForm
                                existingProject={location.state?.projectRecord || null} // Pass existing project data if available
                                onSubmitSuccess={() => (`/page/${user?.id ? encryptId(user.id) : 0}`)} // Redirect to project list on success
                            />
                        </div>
                        <Footer />
                        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
                    </div>
                </ProtectedRoute>
            } />

            <Route path="/AddSkill" element={
                <ProtectedRoute allowedRoles={['professional']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                        <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <AddSkillsForm />
                        </div>
                        <Footer />
                        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
                    </div>
                </ProtectedRoute>
            } />
            <Route path="/AddWorkExperience" element={
                <ProtectedRoute allowedRoles={['professional']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                        <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <AddWorkExperienceForm
                                existingRecords = {location.state?.experienceRecord ? [location.state.experienceRecord] : []}
                                onSubmitSuccess={() => navigate(`/page/${user?.id ? encodeURIComponent(encryptId(user.id)) : 0}`)}
                            />
                        </div>
                        <Footer />
                        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
                    </div>
                </ProtectedRoute>
            } />
            <Route path="/AddEducation" element={
                <ProtectedRoute allowedRoles={['professional']}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
                        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
                        <div style={{ display: 'flex', flex: 1 }}>
                            <SideBar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
                            <AddEducationForm
                                existingRecords={location.state?.educationRecord ? [location.state.educationRecord] : []}
                                onSubmitSuccess={() => navigate(`/page/${user?.id ? encodeURIComponent(encryptId(user.id)) : 0}`)}
                            />
                        </div>
                        <Footer />
                        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
                    </div>
                </ProtectedRoute>
            } />
        </Routes>
    );
};

export default ProfessionalRoutes;